import React, { useEffect, useState } from 'react';
import { Icon, Navbar, NavItem } from 'react-materialize';
import { BLOG_URL, BRAND_SUBTITLE, SITE_NAME, ZOOM_SCHEDULING_LINK } from '../../config/constants';
import logoImage from '../../img/MJRlogo.png';
import './styles.scss';

export const HeaderComponent = () => {
  const [isContactVisible, setIsContactVisible] = useState(false);
  const [isResourcesVisible, setIsResourcesVisible] = useState(false);

  useEffect(() => {
    // Observe the actual booking button element in the contact section only
    const bookingButton = document.querySelector('#contact .booking-button');

    if (bookingButton) {
      const bookingButtonObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            setIsContactVisible(entry.isIntersecting);
          });
        },
        {
          threshold: 0.1, // Trigger when 10% of the button is visible
          rootMargin: '0px',
        }
      );

      bookingButtonObserver.observe(bookingButton);

      return () => {
        bookingButtonObserver.disconnect();
      };
    }
  }, []);

  useEffect(() => {
    // Observe the actual blog button element in the resources section
    const blogButton = document.querySelector('.blog-link-button');

    if (blogButton) {
      const blogButtonObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            setIsResourcesVisible(entry.isIntersecting);
          });
        },
        {
          threshold: 0.1, // Trigger when 10% of the button is visible
          rootMargin: '0px',
        }
      );

      blogButtonObserver.observe(blogButton);

      return () => {
        blogButtonObserver.disconnect();
      };
    }
  }, []);

  return (
    <div className='Header'>
      <Navbar
        id='main-nav'
        fixed
        alignLinks='right'
        menuIcon={<Icon>menu</Icon>}
        brand={
          <a href='/' className='brand-logo'>
            <img src={logoImage} alt={SITE_NAME} className="brand-logo-img" />
            <span className='brand-subtitle'>{BRAND_SUBTITLE}</span>
          </a>
        }
        style={{ backgroundColor: '#FFF' }}
      >
        <NavItem href='#hero' className='hide-on-large-and-up'>Home</NavItem>
        <NavItem href='#about'>About</NavItem>
        <NavItem href='#services'>Services</NavItem>
        <NavItem href='#resources'>Resources</NavItem>
        <NavItem href='#contact'>Contact</NavItem>
      </Navbar>
      <div className="hanging-buttons-container">
        <a
          href={BLOG_URL}
          target='_blank'
          rel='noopener noreferrer'
          className={`blog-link-btn-hanging ${isResourcesVisible ? 'hidden' : ''}`}
        >
          <Icon className='blog-link-icon'>chat</Icon>
          Visit Blog
        </a>
        <a
          href={ZOOM_SCHEDULING_LINK}
          target='_blank'
          rel='noopener noreferrer'
          className={`book-session-btn-hanging ${isContactVisible ? 'hidden' : ''}`}
        >
          <Icon className='book-session-icon'>event</Icon>
          Book a Session
        </a>
      </div>
    </div>
  );
};
